import React from 'react';
import './hrnav.css';

const Navbar = () => {
  const username = localStorage.getItem('name'); // Retrieve the username from session storage

 

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-header">Hira EMS..</div>
        <div className="navbar-welcome">
          {username ? `Welcome, ${username}!` : 'Welcome, Guest!'}
        </div>
      </div>
    
    </nav>
  );
};

export default Navbar;
